import React, { useCallback } from 'react';
import { FileTextOutlined } from '@ant-design/icons';
import { useMutation } from 'react-query';
import { ButtonDownload } from './DownloadDoc.styled';
import srv from '../../../../services';
import { notification } from 'antd';

interface Props {
 record?: Record<string, any>;
 contractId?: string;
 docConnection?: string;
}

const DownloadDoc = ({ contractId, docConnection }: Props) => {
 const { isLoading, onLoad } = useApplicationFile(contractId, docConnection);
 return (
  <>
   <ButtonDownload
    icon={<FileTextOutlined />}
    loading={isLoading}
    onClick={onLoad}
   >
    Скачать
   </ButtonDownload>
  </>
 );
};

function useApplicationFile(contractId, docConnection) {
 const { mutate: request, isLoading } = useMutation(srv.downloadDocConnection, {
  onSuccess: (response: any) => {
   if (response?.docs?.length > 0) {
    notification.success({
     message: 'Документы успешно скачаны',
     placement: 'bottomRight',
     duration: 7,
    });
   } else {
    notification.warning({
     message: 'Документы не найдены',
     placement: 'bottomRight',
     duration: 7,
    });
   }
  },
  onError: () => {
   notification.warning({
    message: 'Документы не найдены',
    placement: 'bottomRight',
    duration: 7,
   });
  },
 });

 const onLoad = () => {
  request({
   contractId: contractId,
   docType: docConnection,
  });
 };

 return { isLoading, onLoad };
}

export default DownloadDoc;
